class Breadcrumbs {
  constructor() {
    this.BlobBreadcrumb = { key: 'all', value: 'All Block of Business' };
    this.EmployerBreadcrumb = { key: 'all', value: 'All Employers' };
    this.LocationBreadcrumb = { key: 'all', value: 'All Locations' };
  }

  getBlobBreadcrumb() {
    return this.BlobBreadcrumb;
  }

  setBlobBreadcrumb(BlobBreadcrumb) {
    this.BlobBreadcrumb = BlobBreadcrumb;
    const event = new Event('blob-update');
    document.dispatchEvent(event);
  }

  getEmployerBreadcrumb() {
    return this.EmployerBreadcrumb;
  }

  setEmployerBreadcrumb(employerBreadcrumb) {
    this.EmployerBreadcrumb = employerBreadcrumb;
    const event = new Event('employer-update');
    document.dispatchEvent(event);
  }

  getLocationBreadcrumb() {
    return this.LocationBreadcrumb;
  }

  setLocationBreadcrumb(locationBreadcrumb) {
    this.LocationBreadcrumb = locationBreadcrumb;
    const event = new Event('location-update');
    document.dispatchEvent(event);
  }

  resetUserListDetails() {
    this.BlobBreadcrumb = { key: 'all', value: 'All Block of Business' };
    this.EmployerBreadcrumb = { key: 'all', value: 'All Employers' };
    this.LocationBreadcrumb = { key: 'all', value: 'All Locations' };
  }
}

export default new Breadcrumbs();
